import { configureEnvironment } from './env';
import React from 'react';
import { createRoot } from 'react-dom/client';

void configureEnvironment()
  .then(async () => {
    const Root = (await import('./Root')).default;
    const { setRedirectURL } = await import('./util/urlRedirect');
    const currentURL = window.location.pathname + window.location.search + window.location.hash;
    setRedirectURL(currentURL);
    return <Root />;
  })
  .catch((error) => {
    console.error('Error during application initialization:', error);
    return <div>Application failed to load</div>;
  })
  .then((it) => {
    const container = document.getElementById('root');
    if (!container) throw new Error('Root element not found');
    const root = createRoot(container);
    root.render(it);
  });